import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { ProgressBar } from 'react-bootstrap';
import cns from 'classnames';
import VerbHeading from '../../../shared/components/VerbHeading';
import VerbButton from '../../../shared/components/VerbButton';
import VerbParagraph from '../../../shared/components/VerbParagraph';
import Image from '../../../shared/components/Image';
import PathwayTimelineModal from '../widgets/PathwayTimelineModal';
import { calculatePercentage } from '../../../shared/utils/NumberUtils';
import { IMAGE_PROPS } from '../../../shared/utils/ImageUtils';

export default class NextAssetContainer extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            modalOpen: false
        };
    }

    static propTypes = {
        loggedInUser: PropTypes.object,
        nextLearningAsset: PropTypes.object,
        handleContinue: PropTypes.func,
        totalCollectionAssets: PropTypes.number,
        totalCollectionAssetsComplete: PropTypes.number,
        currentUserPathway: PropTypes.object
    };

    _handleClick = () => {
        const { handleContinue } = this.props;
        const { loading } = this.state;
        if (loading) {
            return null;
        }
        this.setState({ loading: true });
        return handleContinue().then(() => this.setState({ loading: false }));
    };

    _getStatus = (userCollection) => {
        if (!userCollection || isEmpty(userCollection)) {
            return 'notSubscribed';
        }
        if (userCollection.badgeId) {
            return 'hasBadge';
        }
        return 'noBadge';
    };

    _makePathwayAssetThumbnail = () => {
        const imageProps = IMAGE_PROPS.pathwayAssetInterstitialImageCloudinary;
        const pathwayImages = [
            'https://res.cloudinary.com/verb-prod/image/upload/v1594671134/Pathways_ActivityInterstitialHerbie1_sqmosa.png',
            'https://res.cloudinary.com/verb-prod/image/upload/v1594671134/Pathways_ActivityInterstitialHerbie2_jpr3p5.png',
            'https://res.cloudinary.com/verb-prod/image/upload/v1594671134/Pathways_ActivityInterstitialHerbie3_oi5l2a.png'
        ];

        const randomNum = Math.floor(Math.random() * 3) + 1;

        const randomImage = pathwayImages[randomNum - 1];

        return (
            <Image
                src={randomImage}
                dimension={imageProps.dimension}
                CloudinaryCrop={imageProps.cloudinaryCrop}
                quality={{ q: 100 }}
                className={'trackCardImage pull-left'}
            />
        );
    };

    handleModalClick = () =>
        this.setState((prevstate) => {
            const { modalOpen } = prevstate;
            return { modalOpen: !modalOpen };
        });

    render() {
        const {
            nextLearningAsset = {},
            totalCollectionAssets = 0,
            totalCollectionAssetsComplete = 0,
            currentUserPathway = {}
        } = this.props;
        const { loading, modalOpen } = this.state;
        const isInCurrentPathway = !isEmpty(currentUserPathway);
        const progress =
        !isInCurrentPathway && calculatePercentage(totalCollectionAssetsComplete, totalCollectionAssets);
        return (
            <div className={`next-asset-section row ${isInCurrentPathway ? 'asset-pathway' : ''}`}>
                <div className={'container next-asset-container'}>
                    <div className={cns('col-12 interstitial-progress')}>
                        <div className={cns('progress-bar-container')} hidden={!progress}>
                            <VerbHeading
                                className={'progress-bar-label'}
                                messageId={'ASSET_INTERSTITIAL_COLLECTION_PROGRESS_TEXT'}
                                hNumber={6}
                                defaultMessage={'PATH PROGRESS'}
                            />
                            <ProgressBar now={progress} />
                        </div>
                        <div className={'next-asset-container'}>
                            <div className={'next-asset-image-container'}>
                                <Image className={"next-asset-thumbnail"} src={nextLearningAsset.thumbnailImageUrl} dimension={{ h: 160, w: 160 }} />
                            </div>
                            <div className={'asset-details'}>
                                <VerbHeading
                                    className={'up-next-label'}
                                    messageId={'ASSET_INTERSTITIAL_UP_NEXT'}
                                    hNumber={6}
                                    defaultMessage={'NEXT ACTIVITY'}
                                />
                                <h4 className={'asset-title'}>{nextLearningAsset && nextLearningAsset.name}</h4>
                                <VerbButton
                                    textId={'BUTTON_KEEP_LEARNING'}
                                    defaultMessage={'BEGIN'}
                                    onClick={this._handleClick}
                                    className={cns('asset-interstitial-button', { loading })}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <PathwayTimelineModal
                    isOpen={modalOpen}
                    handleModalClose={this.handleModalClick}
                    userPathwayId={currentUserPathway._id}
                />
            </div>
        );
    }
}
